module.exports = __webpack_public_path__ + "img/preview-smartphone.e6fa02c5.png";